import { combineReducers } from 'redux';
import { Leads_manage } from './leads_manage.reducer';
import { Lead_profile } from '../../../Lead_profile/redux/reducers/index';
import { Lead_create } from '../../../Lead_create/redux/reducers/lead_create.reducers';
import { Lead_approval } from '../../../Lead_approval/redux/reducers/lead_approval_get_leads.reducer';
import { LeadPaymentApproval } from '../../../LeadPaymentApproval/redux/reducers';
import { CustomersList } from '../../../CustomersList/redux/reducers';


export const Leads = combineReducers({
    Leads_manage,
    Lead_profile,
    Lead_create,
    Lead_approval,
    LeadPaymentApproval,
    CustomersList,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/reducers/index.js